<nav class="navbar navbar-expand-lg bg-primary navbar-absolute navbar-transparent" color-on-scroll="500">
  <div class="container">
    <div class="navbar-wrapper">
      <a class="navbar-brand d-none d-sm-none d-md-block">{{getNavbarTitle() | translate}}
      </a>
      <a class="navbar-brand d-block d-sm-block d-md-none">{{getNavbarTitle() | translate}}</a>
    </div>
    <span #navbarContainer class="navbar-container" >
      <button mat-button class="navbar-toggler" type="button" (click)="sidebarToggle()">
        <span class="sr-only">Toggle navigation</span>
        <span class="navbar-toggler-icon icon-bar"></span>
        <span class="navbar-toggler-icon icon-bar"></span>
        <span class="navbar-toggler-icon icon-bar"></span>
      </button>
      <div class="collapse navbar-collapse justify-content-end sidebar-hide-on-resize">
        <ul class="navbar-nav" #navbarCollapse>
          <li class="nav-item" routerLinkActive="active">
            <a class="nav-link" [routerLink]="['/register']">
              <i class="material-icons notranslate">person_add</i> {{'HEADER.REGISTER' | translate}}
            </a>
          </li>
          <li class="nav-item" routerLinkActive="active">
            <a class="nav-link" [routerLink]="['/login']">
              <i class="material-icons notranslate">fingerprint</i> {{'HEADER.LOGIN' | translate}}
            </a>
          </li>
        </ul>
        <app-language-switch-item></app-language-switch-item>
      </div>
    </span>
  </div>
</nav>
